import { observer } from 'mobx-react-lite';
import { Outlet } from 'react-router';
import { ModalContainer } from '../views/common/modal/Modal';
import { ToastContainer } from '../views/common/toast/ToastContainer';

const ListeningPublicLayout = observer(() => {
    return (
        <>
            <div className="min-h-dvh w-full">
                <Outlet />
            </div>
            <ModalContainer />
            <ToastContainer />
        </>
    );
});

export default ListeningPublicLayout;
